/******************************************************************************************
 *	Purchase Authorization Service
 *******************************************************************************************/
(function() {
  

  angular.module('rcServices.purchaseAuthorization', []).service(
    'PurchaseAuthorization',
    /* @ngInject */
    function($q, DemoMode, jilResellerCustomers, MiniJil, User) {
      //Create new PA
      this.post = function(customerId, payload) {
        if (DemoMode.isEnabled()) {
          const data = MiniJil.createPurchaseAuthorization(customerId, payload);
          if (data) {
            return $q.resolve(data);
          } else {
            return $q.reject({
              data: {},
              status: 400
            });
          }
        } else {
          return jilResellerCustomers.customerPurchases.save(
            {
              customerId,
              resellerId: User.getResellerID()
            },
            payload
          ).$promise;
        }
      };

      //Cancel PA
      this.cancel = function(customerId, purchaseId) {
        if (DemoMode.isEnabled()) {
          const data = MiniJil.cancelPurchaseAuthorization(customerId, purchaseId);
          if (data) {
            return $q.resolve(data);
          } else {
            return $q.reject({
              data: {},
              status: 400
            });
          }
        } else {
          return jilResellerCustomers.customerPurchases.delete({
            customerId,
            purchaseId,
            resellerId: User.getResellerID()
          }).$promise;
        }
      };
    }
  );
})();
